module.exports = __webpack_public_path__ + "img/autoinmunes.dcf37734.png";